<template>
  <md-dialog-prompt
    ref="dialog"

    :value="value !== null ? value : ''"
    @input="$emit('input', arguments[0])"
    md-title="Введите имя документа"
    md-input-maxlength="30"
    :md-confirm-text="confirmText"
    @close="close"
  />
</template>

<script>
export default {
  props: {
    value: String,
    confirmText: {
      type: String,
      default: 'Переименовать'
    }
  },
  methods: {
    open () {
      this.$refs.dialog.open()
    },
    close (button) {
      if (button === 'ok') {
        this.$emit('confirm')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// DocNameDialog.vue?747ad4db